import { FlowDurationUnits, FlowIteratorBlockErrorResolution } from 'flow-schema';

import { api } from 'common';

import { IteratorBlockFormFields } from './FormFields';
import { IteratorBlockDocumentationMarkdown } from './documentation';
import { BlockType } from '../../../../types';
import type { BlockConfigProps } from '../../../types';
import { llmPromptBlockDefaultConfig } from '../../Llm/Shared/constants';

export const iteratorV1Config: BlockConfigProps<api.FlowDefinition.IteratorV1Block['config']> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'iterator',
  defaultConfig: {
    items: '',
    itemKey: '',
    action: {
      type: BlockType.LlmPrompt,
      config: llmPromptBlockDefaultConfig,
    },
    errorResolution: FlowIteratorBlockErrorResolution.Continue,
    iterationStepDuration: {
      value: 0,
      units: FlowDurationUnits.Seconds,
    },
  },
  configFields: {
    schema: api.FlowDefinition.IteratorV1BlockConfigSchema,
    FormFields: IteratorBlockFormFields,
  },
  documentationMarkdown: IteratorBlockDocumentationMarkdown,
};
